import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconCode, IconSearch, IconSettings } from '@posthog/icons';
import Beta from "../../../../contents/docs/logs/_snippets/beta.mdx";
import * as React from 'react';
export default {
  QuestLog,
  QuestLogItem,
  IconCode,
  IconSearch,
  IconSettings,
  Beta,
  React
};